"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldFeedback = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const FormFieldFeedback_styles_1 = require("./FormFieldFeedback.styles");
/**
 * @deprecated Use `Form.Field` and `Form.Error` instead
 */
const FormFieldFeedback = (_a) => {
    var { variant, text } = _a, props = __rest(_a, ["variant", "text"]);
    const getIconWrapper = () => {
        if (!text)
            return null;
        return (react_1.default.createElement(FormFieldFeedback_styles_1.StyledIconWrapper, null,
            variant === "error" && (react_1.default.createElement(__1.Icon, { colour: "red", name: "Error", size: 3, style: "Fill", props: { "aria-hidden": true } })),
            variant === "success" && (react_1.default.createElement(__1.Icon, { colour: "green", name: "Success", size: 3, style: "Fill", props: { "aria-hidden": true } })),
            variant === "warning" && (react_1.default.createElement(__1.Icon, { colour: "orange", name: "Warning", size: 3, style: "Fill", props: { "aria-hidden": true } }))));
    };
    return (react_1.default.createElement(FormFieldFeedback_styles_1.StyledFormFieldFeedback, Object.assign({}, props, { "aria-live": "assertive" }),
        getIconWrapper(),
        text && react_1.default.createElement(__1.Text, { skinny: true }, text)));
};
exports.FormFieldFeedback = FormFieldFeedback;
//# sourceMappingURL=FormFieldFeedback.js.map